export const basicosEndpoint = {
    // Bancos
    bancos: {
        listar: `/api/v1/financeiro/bancos`,
        criar: `/api/v1/financeiro/bancos`,
        atualizar: (id) => `/api/v1/financeiro/bancos/${id}`,
        cancelar: (id) => `/api/v1/financeiro/bancos/${id}/cancelar`,
    },

    // Tipo Chave Pix
    tipoChavePix: {
        listar: `/api/v1/basicos/tipo-chave-pix`,
    },

    // Escolaridades
    escolaridades: {
        listar: `/api/v1/basicos/escolaridades`,
    },

    // Áreas de Atuação
    areasAtuacao: {
        listar: `/api/v1/basicos/areas-atuacao`,
    },

    // Raça e Etnia
    racaEtnia: {
        listar: `/api/v1/basicos/racas`,
    },

    // Gênero
    genero: {
        listar: `/api/v1/basicos/generos`,
    },

    // Orientação Sexual
    orientacaoSexual: {
        listar: `/api/v1/basicos/orientacoes-sexuais`,
    },

    // Rubricas Financeiras
    rubricasFinanceiras: {
        listar: `/api/v1/basicos/rubricas-financeiras`,
        listarSubrubricasPorDetalheRubricaId: (id) => `/api/v1/basicos/rubricas-financeiras/detalhes/${id}/subrubricas`,
    },

    // Subrubricas Financeiras
    subrubricasFinanceiras: {
        listar: `/api/v1/basicos/subrubricas-financeiras`,
        criar: `/api/v1/basicos/subrubricas-financeiras`,
        atualizar: (id) => `/api/v1/basicos/subrubricas-financeiras/${id}`,
        apagar: (id) => `/api/v1/basicos/subrubricas-financeiras/${id}`,
    },

    // Tipos de Instrumentos Jurídicos
    tiposInstrumentosJuridicos: {
        listar: `/api/v1/basicos/tipos-instrumentos-juridicos`,
    },

    // Tipos de Hospedagem
    tiposHospedagem: {
        listar: `/api/v1/basicos/tipos-hospedagem`,
    },

    // Tipos de Aditivos
    tiposAditivos: {
        listar: `/api/v1/basicos/tipos-aditivos`,
    },

    // Tipos de Aplicação Financeira
    tiposAplicacaoFinanceira: {
        listar: `/api/v1/basicos/tipos-aplicacao-financeira`,
        criar: `/api/v1/basicos/tipos-aplicacao-financeira`,
        atualizar: (id) => `/api/v1/basicos/tipos-aplicacao-financeira/${id}`,
        apagar: (id) => `/api/v1/basicos/tipos-aplicacao-financeira/${id}`,
    },

    // Labels
    labels: {
        listar: `/api/v1/basicos/labels`,
    },

    // Status de Projetos
    statusProjetos: {
        listar: `/api/v1/basicos/status-projetos`,
    },

    // Modalidades de Bolsas
    modalidadesBolsas: {
        listar: `/api/v1/basicos/modalidades-bolsas`,
    },

    // Tipos de Membros
    tiposMembros: {
        listar: `/api/v1/basicos/tipos-membros`,
    },

    // Status de Solicitações
    statusSolicitacoes: {
        listar: `/api/v1/basicos/status-solicitacoes`,
    },

    // Status de Solicitações Administrativas
    statusSolicitacoesAdm: {
        listar: `/api/v1/basicos/status-solicitacoes-adm`,
    },

    // Status de Solicitações CLT
    statusSolicitacoesClt: {
        listar: `/api/v1/basicos/status-solicitacoesclt`,
    },

    // Tipos de Solicitações
    tiposSolicitacoes: {
        listar: `/api/v1/basicos/tipos-solicitacoes`,
    },

    // Tipo Solicitações Projetos
    tipoSolicitacoesProjetos: {
        listar: `/api/v1/basicos/tipo-solicitacoes-projetos`,
    },

    // Tipo Solicitações Financeiro
    tipoSolicitacoesFinanceiro: {
        listar: `/api/v1/basicos/tipo-solicitacoes-financeiro`,
    },

    // Tipos de Impostos
    tiposImpostos: {
        listar: `/api/v1/basicos/tipos-impostos`,
    },

    // Tipos de Contratação Status
    tiposContratacaoStatus: {
        listar: `/api/v1/basicos/tipos-contratacao-status`,
    },

    // Lotes Pagamento Banco Status
    lotesPagamentoBancoStatus: {
        listar: `/api/v1/basicos/lotes-pagamento-banco-status`,
    },

    // Tipo Pagamento Status
    tipoPagamentoStatus: {
        listar: `/api/v1/basicos/tipopagamentostatus`,
    },

    // Tipo Relatório Viagem Status
    tipoRelatorioViagemStatus: {
        listar: `/api/v1/basicos/tiporelatoriosolicitacaostatus`,
    },

    // Tipos de Cargos
    tiposCargos: {
        listar: `/api/v1/basicos/tipos-cargos`,
    },

    // Tipos de Pessoas Jurídicas
    tiposPessoasJuridicas: {
        listar: `/api/v1/basicos/tipos-pessoas-juridicas`,
    },

    // Email
    email: {
        listarEnviados: `/api/v1/basicos/email/enviados/fake`,
    },

    // Veículo Categoria
    veiculoCategoria: {
        listar: `/api/v1/basicos/veiculocategoria`,
    },

    // Ocupação CBO
    ocupacaoCbo: {
        listar: `/api/v1/basicos/ocupacaocbo`,
    },

    // Tipos de Benefícios CLT
    tiposBeneficiosClt: {
        listar: `/api/v1/basicos/tipos-beneficios-clt`,
    },

    // Tipo Folha CLT
    tipoFolhaClt: {
        listar: `/api/v1/basicos/tipo-folha-clt`,
        criar: `/api/v1/basicos/tipo-folha-clt`,
        atualizar: (id) => `/api/v1/basicos/tipo-folha-clt/${id}`,
        apagar: (id) => `/api/v1/basicos/tipo-folha-clt/${id}`,
    },

    // Tipo Rescisão CLT
    tipoRescisaoClt: {
        listar: `/api/v1/basicos/tipo-rescisao-clt`,
        criar: `/api/v1/basicos/tipo-rescisao-clt`,
        atualizar: (id) => `/api/v1/basicos/tipo-rescisao-clt/${id}`,
        apagar: (id) => `/api/v1/basicos/tipo-rescisao-clt/${id}`,
    },

    // Tipos de Processos
    tiposProcessos: {
        listar: `/api/v1/administrativo/tipos-processos/paginado`,
        criar: `/api/v1/administrativo/tipos-processos`,
        obter: (id) => `/api/v1/administrativo/tipos-processos/${id}`,
        atualizar: (id) => `/api/v1/administrativo/tipos-processos/${id}`,
    },

    // Tipo Esferas
    tipoEsferas: {
        listar: `/api/v1/basicos/tipos-esferas`,
        listarEncargosPorTipo: (id) => `/api/v1/basicos/tipos-esferas/${id}/encargos`,
    },

    // IPs Permitidos
    ipsPermitidos: {
        listar: `/api/v1/basicos/ips-permitidos`,
        criar: `/api/v1/basicos/ips-permitidos`,
        atualizar: (id) => `/api/v1/basicos/ips-permitidos/${id}`,
        apagar: (id) => `/api/v1/basicos/ips-permitidos/${id}`,
    },
}
